import React from 'react';
import PropTypes from 'prop-types';

import { OverlayContent } from '../Overlay';

const DrawerContent = ({ children, scroll, p = 4, ...rest }) => {
  return (
    <OverlayContent scroll={scroll} p={p} {...rest}>
      {children}
    </OverlayContent>
  );
};

DrawerContent.propTypes = {
  children: PropTypes.any.isRequired,
  scroll: PropTypes.bool,
};

export default DrawerContent;
